﻿﻿export interface IRegistration {
    id: number;
    centerId: number;
    isPrivateLabel: boolean;
    editKey: string;
    currentRegistrationStep: number;
    firstName: string;
    middleInitial: string;
    lastName: string;
    phoneNumber: string;
    phoneNumberSecondary: string;
    email: string;
    entryDomain: string;
}
